import {
  Container,
  Heading,
  Box,
  SimpleCarousel,
} from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { createLinkHref } from '@moonpig/web-core-link'
import { Region } from '@moonpig/web-core-types'
import { Button } from './Button'
import { useFindLocaleText } from '../../text-localisation'

const createRelatedTermUrl = ({
  term,
  region,
}: {
  term: string
  region: Region
}) => {
  const formattedTerm = term.toLowerCase().replace(/\s/g, '-')
  return `${process.env.HOST_URL}/${region}/d/cards/${formattedTerm}/`
}

type RelatedTermsCarouselProps = {
  terms: string[]
  region: Region
}

export const RelatedTermsCarousel: FC<RelatedTermsCarouselProps> = ({
  terms,
  region,
}) => {
  const localiseText = useFindLocaleText()
  return (
    <Box mb={8}>
      <Container
        limitWidth
        padding={0}
        data-testid="pdp-related-terms-carousel"
      >
        <Heading
          level="h3"
          mb={4}
          ml={{ xs: 0, md: 10 }}
          typography={{ xs: 'typeMobileDisplay04', md: 'typeDesktopDisplay05' }}
          id="related-terms-carousel-heading"
        >
          {localiseText('common.explore_related_categories')}
        </Heading>
        <Box mx={{ md: -6 }}>
          <SimpleCarousel
            gap={0}
            aria-labelledby="related-terms-carousel-heading"
            centerNonScrollableItems
          >
            {terms.map((term, index) => {
              const isFirstElement = index === 0
              const isLastElement = index === terms.length - 1
              const linkHref = createLinkHref({
                url: createRelatedTermUrl({ term, region }),
              })
              return (
                <Button
                  key={term}
                  title={term}
                  linkHref={linkHref}
                  isFirst={isFirstElement}
                  isLast={isLastElement}
                />
              )
            })}
          </SimpleCarousel>
        </Box>
      </Container>
    </Box>
  )
}
